<template>
    <div class="viewEditor" v-if="!disabled">
      <a-tabs default-active-key="content" tab-position="right">
<a-tab-pane key="setup" tab="Nastavenia">

  <a-form-item
                class="setup-item"
                label="Typ obsahu"
                has-feedback
        >  <a-select @change="handleChange" v-model="data['settings']['contentType']" >
            <a-select-option  :key="'contenttype:' + editid + ct.id"  :value="ct.slug"  v-for="ct in contenttypes">{{ct.title}}</a-select-option>
        </a-select>
        </a-form-item>
        <div class="mt-2" v-if="contenttypeFields">
        <a-form-item>
        Konkrétne položky <template v-if="data['settings']['specificNodes']"><strong>({{ data['settings']['specificNodes'].length }})</strong></template>
        <a-button @click="openProductSearch('specificNodes')" class="float-right">vybrať</a-button>
    </a-form-item>
    <a-form-item>
        Ignoruj položky <template v-if="data['settings']['ignoreNodes']"><strong>({{ data['settings']['ignoreNodes'].length }})</strong></template>
        <a-button @click="openProductSearch('ignoreNodes')" class="float-right">vybrať</a-button>
    </a-form-item>

            </div>
        <a-form-item v-if="nodespecific"
                     class="setup-item"
                     label="Použiť node zo stránky"
                     has-feedback
        >
            <a-switch v-if="nodespecific" :defaultChecked="data['settings']['nodeSpecific']" @change="onChange"></a-switch>
        </a-form-item>


        <a-form-item
                class="setup-item"
                label="Slovník"
                has-feedback
        >  <a-select @change="handleChangeTax" v-model="data['settings']['taxonomyfilter']" >
            <a-select-option  :key="'taxonomy:' + editid + ct.id"  :value="ct.slug"  v-for="ct in taxonomies">{{ct.title}}</a-select-option>
        </a-select>
        </a-form-item>

        <a-form-item
                class="setup-item"
                label="Jazyk"
                has-feedback
        ><a-select @change="handleChangeLang" v-model="data['settings']['lang']">
            <a-select-option :key="'taxonomy:' + editid + ct.id"  :value="ct.id"  v-for="ct in dataLang">{{ct.title}}</a-select-option>
        </a-select>
        </a-form-item>
        <a-form-item
                class="setup-item"
                label="Počet položiek"
                has-feedback
        > <a-input  v-model="data['settings']['count']" />
        </a-form-item>
        <a-form-item
                class="setup-item"
                has-feedback
        >  <a-checkbox v-model="data['settings']['published']" @change="handleChangeElement" >Zobraz nepublikované</a-checkbox>
        </a-form-item>
          <a-form-item
                class="setup-item"
                has-feedback
        >  <a-checkbox v-model="data['settings']['pagination']"  @change="handleChangeElement">Zobraz stránkovanie</a-checkbox>
        </a-form-item>
        <a-form-item
                class="setup-item"
                has-feedback
        >  <a-checkbox v-model="data['settings']['ignoreEmpty']"  @change="handleChangeElement">Schovaj blok ak prázdne</a-checkbox>
        </a-form-item>
          <a-form-item
                class="setup-item"
                label="počet položiek na stránku"
                has-feedback
        >     <a-input :disabled="!data['settings']['pagination']"  v-model="data['settings']['itemsperpage']" @change="handleChangeElement"/>
        </a-form-item>
        <a-form-item v-if="url"
                     class="setup-item"
                     has-feedback
        >
            <a-checkbox v-model="data['settings']['urlParameter']" v-if="url.includes('/*')"  @change="handleChangeElement">Použiť node z parametra</a-checkbox>
        </a-form-item>

        <a-form-item
                class="setup-item"
                has-feedback
        >  <a-checkbox v-model="data['settings']['hierarchy']" >Zahrnúť hierarchiu</a-checkbox>
        </a-form-item>

</a-tab-pane>
<a-tab-pane key="content" tab="Obsah">
  <div   v-if="contenttypeFields || data.settings.taxonomyfilter">


<div class="element">
    <a-form-item
            label="Filtrovanie"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            has-feedback
    >  <a-select mode="multiple"
    class="w-90" v-model="data['settings']['filterBy']" >
       <a-select-option key="filter:none"  value="">Nefiltrovať</a-select-option>
       <a-select-option key="filter:custom_text"  value="custom_text">Iba prepis</a-select-option>
       <a-select-option key="filter:id"  value="id">ID</a-select-option>
        <a-select-option :value="ct.id" :key="'filterfield:' + ct.id" v-for="ct in contenttypeFields.fields">{{ct.title}}</a-select-option>
    </a-select>
        <div  class="float-right">
            <a-button size="small" @click="openFilterSetup('filter')"><i class="fas fa-pencil-alt"></i></a-button>
        </div>
    </a-form-item>
</div>
<div class="element">
    <a-form-item
            label="Usporiadať"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            has-feedback
    >
        <a-select  v-model="data['settings']['orderBy']" class="w-90">
            <a-select-option key="orderby:none" value="">Neusporiadávať</a-select-option>
            <a-select-option key="ID"  value="id">ID stránky</a-select-option>
            <a-select-option key="RANDOM"  value="random">Náhodne</a-select-option>
             <a-select-option key="modified"  value="modified">Času poslednej zmeny</a-select-option>
             <a-select-option key="created"  value="created">Času vytvorenia</a-select-option>
                  <a-select-option key="datum"  value="datum">Dátumu vydania</a-select-option>
            <a-select-option :value="ct.slug" :key="'orbderbyfield:' + ct.id" v-for="ct in contenttypeFields.fields">{{ct.title}}</a-select-option>
        </a-select>
        <div  class="float-right">
          <a-button size="small" v-if="data.settings.orderBy" @click="openOrderSetup('orderby')"><i class="fas fa-pencil-alt"></i></a-button>
        </div>
    </a-form-item>
</div>
<div class="element" v-for="(el,i) in elements">
    <a-form-item :key="editid + '-fields:' + i"
                 :label-col="labelCol"
                 :wrapper-col="wrapperCol"
                 :label="fields ? (fields[el] ? fields[el].name : el) : el"
                 has-feedback
    >
        <a-select v-model="data[el]" @change="handleChangeElement"  class="w-90">
            <a-select-option :key="'contenttype:' + i + 'none'"  value="">Nezobrazovať</a-select-option>
            <a-select-option :key="'contenttype:' + i + 'custom_text'"  value="custom_text">Iba prepis</a-select-option>
            <a-select-option :value="ct.slug" :key="'contenttypefield:' + ct.id" v-for="ct in contenttypeFields.fields">{{ct.title}}</a-select-option>
        </a-select>
        <div  class="float-right">
          <a-button size="small"  @click="openSetup(el)"><i class="fas fa-pencil-alt"></i></a-button>
        </div>
    </a-form-item>
</div>
</div>

</a-tab-pane>

      </a-tabs>


    <a-modal :title="'Vyhľadávanie v položkách: ' + (productSlug == 'specificNodes' ? 'ukáž vybrané' : 'ignoruj vybrané')" :width="1200" centered v-model="productSearch" :footer="false">
      <a-row :gutter="36">
        <a-col :span="8">
<h6>Vybrané položky</h6>
<div :key="rearangablefiles">
  <draggable
    v-bind="dragOptions"
    v-model="data['settings'][productSlug]"
    @change="rearanged"
    group="newcomponents"
    handle=".handle"
    class="rearange-table"
  >
    <transition-group>
      <template v-for="(spn,ind) in (data['settings'][productSlug] || [])">
        <div :key="'spn' + (spn.value || spn.key)" class="w-100">
          <a class="handle mr-2"><i class="fa fa-expand-arrows-alt"></i></a>
          {{ spn.label }} ({{ spn.value || spn.key }})
          <a class="float-right" @click="removeItemFrom(productSlug, ind)">x</a>

          <!-- Oko len pre 'specificNodes' (má zmysel pre override detail) -->
          <a
            v-if="productSlug === 'specificNodes'"
            class="float-right"
            @click="getProductDetail(spn.value ? spn.value : spn.key)"
          ><i class="fas fa-eye pr-1"></i></a>
        </div>
      </template>
    </transition-group>
  </draggable>
</div>
        </a-col>
     <a-col :span="16">

                <a-form-item :label-col="{span: 24}" :wrapper-col="{span: 24}" label="Vyhľadávanie v položkách" class="mb-0">
  <a-input-search
    placeholder="Zadajte názov, značku, alebo kód položky"
    @search="(e) => fetchUser(e, data['settings']['contentType'])"
  />
</a-form-item>
<!-- Manuálny vstup -->
<a-divider class="mt-3 mb-2">Manuálna položka</a-divider>
<a-form layout="vertical" @submit.prevent>
  <a-row :gutter="8">
    <a-col :span="10">
      <a-form-item label="Názov (label)">
        <a-input v-model="manual.label" placeholder="napr. Produkt bez v databáze" />
      </a-form-item>
    </a-col>
    <a-col :span="8">
      <a-form-item label="ID / kód (nepovinné)">
        <a-input v-model="manual.id" placeholder="ak necháš prázdne, vygenerujeme" />
      </a-form-item>
    </a-col>
    <a-col :span="6" style="display:flex;align-items:flex-end;">
      <a-button type="primary" block @click="addManual">Pridať manuálne</a-button>
    </a-col>
  </a-row>
  <small class="text-muted">
    Manuálne položky dostanú ID s prefixom <code>m:</code> (napr. <code>m:169...</code>) a môžeš ich ťahať, mazať a pri „Konkrétne položky“ aj prepisovať polia.
  </small>
</a-form>

<a-spin v-if="fetching" slot="notFoundContent" size="small" />
<div class="finduser clickable-td" v-if="searchdata.length > 0" style="max-height:300px;overflow-y:scroll">
<div class="mb-3">Výsledky vyhľadávania:</div>
    <table class="w-100" >
        <template  v-for="user in searchdata">
                    <tr :key="user.id" class="selectable-row">
                    <td v-if="user.image" style="width:60px;margin-right:12px;text-align:center;"><span><img :src="user.image.styled" width="100%"></span></td>
                    <td v-else style="width:60px;text-align:center;">-</td>
                    <td style="width:200px;"><span>{{user.value}}</span></td>
                    <td style="width:150px;display:block;">{{user.url}}</td>
                    <td v-if="user.price" style="width:100px;display:block;text-align:right;">{{user.price}} €</td>
                    <td v-else style="width:100px;display:block;text-align:center;">-</td>
                    <td style="width:100px;text-align:right;display:block;"><a-button @click="addProductItem(user)">pridať</a-button></td>
                    </tr>
        </template>
    </table>
</div>
<div v-if="multidata.id && productLoaded" class="override-node">
  <h4>Prepis polí konkrétnej položky</h4>
  <template v-for="mdata,slug in elements">

    <div :key="'node' + slug + multidata.id">
    <div v-if="fieldTypes[data[mdata]] == 3" class="mb-2">
    <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template>:</label>
    <image-upload :data="multidata[data[mdata]]" :label="mdata" :dat="slug"  @changed="(e) => onChildChange(e,data[mdata])"></image-upload>
</div>

<div v-if="fieldTypes[data[mdata]] == 12 && productLoaded" class="mb-2">
    <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template>:</label>
    <a-select v-model="multidata[data[mdata]]" :options="fieldOptions[data[mdata]]" class="w-100" ></a-select>
</div>

<div v-if="fieldTypes[data[mdata]] == 1 || fieldTypes[data[mdata]] == 6" class="mb-2">
  <a-row :gutter="6">
    <a-col :span="12">
  <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template>:</label>
    <a-input v-model="multidata[data[mdata]]"/>
  </a-col>
  <a-col :span="12" v-if="data[mdata] != 'url' && fieldTypes[data[mdata]] != 6">
    <label class="form-control-label"><template v-if="fields[mdata].name">{{fields[mdata].name}}</template><template v-else>{{mdata}}</template> suffix:</label>
    <a-input v-model="multidata[data[mdata]+'_suffix']"/>
  </a-col>
  <a-col  :span="12" v-if="data[mdata] == 'url'" style="text-align:right">
    <label class="form-control-label w-100"></label>
    <a v-if="multidata.url" :href="vars.site_url + '/' + multidata.language + '/' + multidata.url"  target="_blank" class="mt-4" >
                    <template>
                        <a-button type="secondary">Zobraziť stránku</a-button>
                    </template>
                </a>
                 <router-link :to="'/edit-content/' + multidata.id" > <a-button type="secondary">Uprav stránku</a-button></router-link>
  </a-col>
  </a-row>
</div>


    </div>
  </template>
  <a-row>
    <a-col :span="24" class="text-right">
      <a-button type="primary" @click="saveOverride">Ulož prepis</a-button>
    </a-col>
  </a-row>

</div>
</a-col>

</a-row>
      </a-modal>


        <a-modal title="Nastavenie poľa" centered v-model="setupVisible" @ok="handleOk">
            <div class="additional-setup">
                <a-form-item :key="selectedElement + '-fields:'" v-if="selectedElement === 'row.image'" :label-col="labelCol" :wrapper-col="wrapperCol" label="Štýl obrázka" has-feedback>
                    <a-select  :defaultValue="data[selectedElement+'_style']" placeholder="štýl obrázka" v-model="data[selectedElement+'_style']" :options="styles"/>
                </a-form-item>
                <a-form-item :key="selectedElement + '-fields:'" v-if="selectedElement === 'row.image'" :label-col="labelCol" :wrapper-col="wrapperCol" placeholder="šírka:výška" label="Vlastný rozmer" has-feedback>
                    <a-input  :defaultValue="data[selectedElement+'_style']" placeholder="štýl obrázka" v-model="data[selectedElement+'_style']"/>
                </a-form-item>

                <a-form-item :key="selectedElement + '-fieldsSetup'" :label-col="labelCol" :wrapper-col="wrapperCol" label="Prepis poľa" has-feedback>
                    <textarea ref="yourTextarea" class="ant-input" :key="'override:' + selectedElement" v-model="data.settings.templates[selectedElement]" :rows="4"/>
                    <ul class="override-text">
                        <li v-for="element in elements"><a @click="copypaste(selectedElement,element)">{{element}}</a></li>
                        <li>----------------</li>
                        <li v-for="element in contenttypeFields.fields"><a @click="copypaste(selectedElement,element.slug)">{{element.title}}</a></li>
                    </ul>
                </a-form-item>
            </div>
        </a-modal>

        <a-modal title="Kontextuálny filter" centered v-model="filterVisible" @ok="handleFilterOk">

        <div>

             <template v-for="(filterit,oio) in data.settings.filterBy" v-if="selectedFields[filterit]">

<a-form-item  :label="selectedFields[filterit].title"  :key="oio">
              <a-select v-if="filterOptions['f' + filterit]"
          mode="multiple"
          style="width: 100%"
          :value="normalizedFilterValue(filterit)"
          @change="(e) => filterbyChange(e, filterit)"
          placeholder="Vyberte ktoré termíny zobraziť">
  <a-select-option
    v-for="i in filterOptions['f' + filterit]"
    :key="i.id"
    :value="i.id">
    {{ i.title }}
  </a-select-option>
</a-select>

                </a-form-item>
               <template v-if="selectedFields[filterit].type == '5'">
  <a-select mode="multiple"
            style="width: 100%"
            :value="normalizedFilterValue(filterit)"
            @change="(e) => filterbyChange(e, filterit)">
    <a-select-option v-for="i in 25" :key="i" :value="i">{{ i }}</a-select-option>
  </a-select>
</template>

                    </template>
                </div>
                <a-form-item v-if="nodespecific"
                             class="setup-item"
                             label="Odfiltrovať node z otvorenej stránky"
                             has-feedback>
                    <a-switch v-if="nodespecific" :defaultChecked="data['settings']['ingoreNodeOn']" @change="onChangen"></a-switch>
                </a-form-item>

                <a-form-item v-if="nodespecific || existField"
                             class="setup-item"
                             label="Použiť hodnotu z otvorenej stránky"
                             has-feedback>
                    <a-switch v-if="nodespecific || existField" :defaultChecked="data['settings']['fieldTaxonomy']" @change="onChangea"></a-switch>
                </a-form-item>

                <a-form-item v-if="vocabulary"
                             class="setup-item"
                             label="Použiť termín taxonómie zo stránky"
                             has-feedback
                >
                    <a-switch v-if="vocabulary" :defaultChecked="data['settings']['taxonomySpecific']" @change="onChanget"></a-switch>
                </a-form-item>

        </a-modal>
        <a-modal title="Usporiadanie" centered v-model="orderbyVisible" @ok="handleOrderbyOk">
            <div class="additional-setup">
                <a-select style="width: 100%"
                          :defaultValue = "data.settings.dir"
                          @change="orderbyChange">
                    <a-select-option key="ASC">Vzostupne</a-select-option>
                    <a-select-option key="DESC">Zostupne</a-select-option>
                </a-select>
            </div>
        </a-modal>

    </div>
</template>

<script>
    import {dataService} from "../../_services";
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import draggable from "vuedraggable";
    import ImageQ from "../content/Image";
import { forEach } from "jszip";

    export default {
        name: "ViewEditor",
        components: {AFormItem, draggable,'image-upload' : ImageQ},
        props: ["data","values","elements","editid","vars","nodespecific","disabled","vocabulary","url","fields","selectedCT","templatesCustom"],
        data() {
            return {
                size: 'small',
                newComponent: null,
                manual: { label: '', id: '' },
                componentId: 0,
                templated: {},
                dataLang: [],
                styles: [],
                override:[],
                orderbyVisible:false,
                template:"",
                setup:[],
                productSlug:"",
                taxonomies: {},
                allBrands:[],
                productSearch:false,
                setupVisible:false,
                nodes:[],
                templates: [],
                context:[],
                lastFetchId:0,
                addtogo:false,
                rearangablefiles:0,
                mainFields: [],
                searchdata:[],
                selectedFields: {},
                fieldTypes:{},
                fieldOptions: {},
                multidata:[],
                searchResults:[],
                selectedElement: '',
                txtContent: '',
                imagetoshow: {},
                productLoaded:false,
                fetching:false,
                existField:false,
                filterOptions:[],
                contenttypes: [],
                contenttypeFields: false,
                dattos: {'settings': {'contentType': '','specificNodes':[],'ignoreNodes':[],'orderby': '','orderbyDirection': '','templates':{}}},
                visible: false,   labelCol: {
                    xs: { span: 24 },
                    sm: { span: 24 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 24 },
                },
                editVisible: false,
                filterVisible: false
            };
        },
        methods: {
            handleChange(id){
                if(id)
                {
                dataService.axiosFetch('contenttype',id).then(results => {
                    this.contenttypeFields = results;

    results.fields.forEach(obj => {

this.selectedFields[obj.id] = obj;

                     });

                });
                this.$emit('changed', this.data);
            }},
            // Always return an array for the select's value
normalizedFilterValue(id) {
  const v = this?.data?.settings?.filter?.[id];

  // If it's already an array, use it
  if (Array.isArray(v)) return v;

  // If it's a number or truthy scalar, wrap into array
  if (typeof v === 'number') return [v];
  if (typeof v === 'boolean') return [v ? 1 : 0];

  // If it's a non-empty string, try to parse JSON safely
  if (typeof v === 'string') {
    const s = v.trim();
    if (!s) return [];
    try {
      const parsed = JSON.parse(s);
      return Array.isArray(parsed) ? parsed : (parsed != null ? [parsed] : []);
    } catch (e) {
      // Fallback when string is not valid JSON
      return [];
    }
  }

  // undefined / null / empty → empty array
  return [];
},

// Keep the internal store as an array (serialize later when saving if needed)
filterbyChange(value, id) {
  // value from a-select in multiple mode is always an array
  this.$set(this.data.settings.filter, id, Array.isArray(value) ? value : (value == null ? [] : [value]));
},

             addManual() {
    if (!this.productSlug) this.productSlug = 'specificNodes';

    // validácia
    const label = (this.manual.label || '').trim();
    if (!label) {
      this.$message && this.$message.warning && this.$message.warning('Zadaj názov (label).');
      return;
    }

    // uistime sa, že existuje cieľové pole (specificNodes/ignoreNodes)
    if (!this.data.settings[this.productSlug]) {
      this.$set(this.data.settings, this.productSlug, []);
    }

    // vygeneruj ID, ak nebolo zadané
    const givenId = (this.manual.id || '').trim();
    const manualId = givenId || `m:${Date.now()}${Math.floor(Math.random()*1000)}`;

    // push do zoznamu (rovnaká štruktúra ako z vyhľadávania)
    this.data.settings[this.productSlug].push({
      value: manualId,
      label,
      manual: true,
    });

    // ak ide o 'Konkrétne položky', priprav aj override kontajner
    if (this.productSlug === 'specificNodes') {
      if (!this.data.settings.override) {
        this.$set(this.data.settings, 'override', {});
      }

      // vyrob prázdny override pre všetky mapované polia (elements → this.data[el])
      const getFields = [];
      this.elements.forEach((obj) => {
        if (this.data[obj]) getFields.push(this.data[obj]);
      });

      const no = { id: manualId, language: (this.data.settings.lang || 'und') };
      getFields.forEach((slug) => {
        no[slug] = '';
        no[slug + '_suffix'] = '';
      });

      this.$set(this.data.settings.override, manualId, no);
      this.multidata = no; // zobraz hneď override editor na pravej strane (ak je viditeľný)
    }

    // refresh reordering key + emit
    this.rearangablefiles += 1;
    this.$emit('changed', this.data);

    // reset formu
    this.manual.label = '';
    this.manual.id = '';
  },
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            rearanged()
            {
              this.$emit('changed', this.data);
            },
            saveOverride()
            {


              if(!this.data.settings.override)
              this.data.settings.override = {};

              if(this.data.settings.override)
              this.data.settings.override[this.multidata.id] = this.multidata;

              this.$emit('changed', this.data);
            },
            handleChangeTax(id){

                dataService.axiosFetch('taxonomy',id).then(results => {
                    this.contenttypeFields = results;
                });

                this.$emit('changed', this.data);
            },
            removeItemFrom(slug,ind)
            {
              this.data['settings'][slug].splice(ind, 1).filter(val => val);
                 this.$emit('changed', this.data);
            },
            fetchUser(value,ct) {

              if(value)
            {
      this.lastFetchId += 1;
      this.searchdata = [];
      this.fetching = true;
      this.fetching = false;
      dataService.axiosPost('findproducts', {searchterm: value,ct:ct}).then(results => {
this.searchdata = results.data.data;
});
}
    },
    addProductItem(theItem)
    {

      if(!this.data['settings']['specificNodes'])
      this.data['settings']['specificNodes'] = [];
this.data['settings']['specificNodes'].push({value: theItem.entity_id, 'label': theItem.value});

this.rearangablefiles = this.rearangablefiles + 1;
  this.$emit('changed', this.data);

    },
            openOverride(el)
            {
                this.override[el] = !this.override[el];
            },
            handleChangeLang(id)
            {
                this.$emit('changed', this.data);
            },
            onChildChange(value,slug) {
                this.multidata[slug] = value;
                 this.$emit('changed', this.data);
            },
            findItAll(ef)
            {

var e = ef.target.value;
              if(e.length > 2)
            {dataService.axiosPost('findnodes', {searchterm: e}).then(results => {

              this.searchResults = results.data.data;
            });
            }
              else
              {this.searchResults = [];}

              },
           openFilterSetup() {
  this.addtogo = false;
  if (!this.data.settings.filter) this.$set(this.data.settings, 'filter', {});
  this.filterOptions = {};

  const filterbyRaw = this.data.settings.filterBy;
  const filterby = Array.isArray(filterbyRaw) ? filterbyRaw : (filterbyRaw ? [filterbyRaw] : []);

  this.existField = false;

  const fields = this.contenttypeFields?.fields || [];
  const totlength = fields.length;
  let ctfi = 0;

  fields.forEach(obj => {
    ctfi += 1;
    if (!filterby.length) return;

    // type 12 → taxonomy
    if (filterby.includes(obj.id) && obj.type === '12') {
      if (!Array.isArray(this.data.settings.filter[obj.id]))
        this.$set(this.data.settings.filter, obj.id, []);
      if (this.contenttypeFields.context &&
          Object.prototype.hasOwnProperty.call(this.contenttypeFields.context, obj.id)) {
        dataService.axiosFetch('taxonomyitems', this.contenttypeFields.context[obj.id]).then(results => {
          this.$set(this.filterOptions, 'f' + obj.id, results);
          this.addtogo = true;
        });
      }
    }

    // type 7 → boolean
    if (filterby.includes(obj.id) && obj.type === '7') {
      if (!Array.isArray(this.data.settings.filter[obj.id]))
        this.$set(this.data.settings.filter, obj.id, []);
      this.$set(this.filterOptions, 'f' + obj.id, [{ id: 1, title: 'Áno' }, { id: 0, title: 'Nie' }]);
    }

    // type 2 → language list
    if (filterby.includes(obj.id) && obj.type === '2' && obj.slug === 'language') {
      if (!Array.isArray(this.data.settings.filter[obj.id]))
        this.$set(this.data.settings.filter, obj.id, []);
      this.$set(this.filterOptions, 'f' + obj.id, this.dataLang);
    }
// type 2 → non-language: take options from contenttypeFields.options
if (
  Array.isArray(filterby) &&
  filterby.map(String).includes(String(obj.id)) &&
  obj.type === '2' &&
  obj.slug !== 'language'
) {
  if (!Array.isArray(this.data.settings.filter[obj.id])) {
    this.$set(this.data.settings.filter, obj.id, []);
  }

  // Try id, then slug, then fallback to empty array
  const raw =
    (this.contenttypeFields?.options?.[obj.id]) ??
    (this.contenttypeFields?.options?.[String(obj.id)]) ??
    (this.contenttypeFields?.options?.[obj.slug]) ??
    [];

  // Normalize shape to [{id, title}]
  const roleops = Array.isArray(raw)
    ? raw.map(opt => ({
        id: opt?.value ?? opt?.id ?? opt,     // be tolerant to shapes
        title: opt?.label ?? opt?.title ?? String(opt)
      }))
    : [];

  // Keep filterOptions as object with per-field bucket
  this.$set(this.filterOptions, 'f' + obj.id, roleops);
}

    if (ctfi === totlength) {
      if (Object.keys(this.filterOptions).length === filterby.length) this.addtogo = true;
    }
  });

  this.filterVisible = true;
},
            openOrderSetup(el)
            {
                if(!this.data.settings.orderBy)
                {this.data.settings.orderBy ="";
                    this.data.settings.dir ="ASC";
                }
                this.orderbyVisible = true;


            },
            orderbyChange(value)
            {
                this.data.settings.dir = value;
                 this.$emit('changed', this.data);
            },

            handleOrderbyOk()
            {
                this.orderbyVisible = false;
                this.$emit('changed', this.data);
            },
            handleSearch(e)
            {

            },
            openSetup(el)
            {
                this.selectedElement = el;
                this.setupVisible = true;

            },
            handleChangeElement()
            {
                this.$emit('changed', this.data);
            },
            handleOk()
            {


                this.setupVisible = false;
                this.selectedElement = null;

                this.$emit('changed', this.data);
            },
            handleFilterOk()
            {

                this.filterVisible = false;
                 this.$emit('changed', this.data);
            },
            onChange(e)
            {
                this.data.settings.nodeSpecific = e;
                 this.$emit('changed', this.data);

            },
            onChanget(e)
            {
                this.data.settings.taxonomySpecific = e;
                 this.$emit('changed', this.data);

            },
            onChangen(e)
            {
                this.data.settings.ingoreNodeOn = e;
                 this.$emit('changed', this.data);

            },
            onChangea(e)
            {
                this.data.settings.fieldTaxonomy = e;
                 this.$emit('changed', this.data);

            },

    getProductDetail(nid) {
  this.productLoaded = false;

  // zozbieraj polia na prácu
  const getFields = [];
  this.elements.forEach(obj => {
    if (this.data[obj]) getFields.push(this.data[obj]);
  });

  const hasOverride = !!(this.data?.settings?.override);
  const overrideForNid = hasOverride && this.data.settings.override[nid] ? this.data.settings.override[nid] : null;

  const fillFromResults = (results, overrideObj) => {
    this.context = results;

    // poskladaj multidata (priorita: override → inak data z content → inak '')
    const no = { id: nid, language: results?.data?.language };
    getFields.forEach(slug => {
      const val = overrideObj ? (overrideObj[slug] ?? '') : (results?.data?.[slug] ?? '');
      no[slug] = val;
      no[slug + '_suffix'] = '';
    });
    this.multidata = no;

    // naplň selecty; vráti Promise
    return this.manageOptions();
  };

  if (hasOverride) {
    if (overrideForNid) {
      // zachovávam tvoju override vetvu (tu máš „prvé volanie“ – priradenie override)
      this.multidata = overrideForNid;

      // ALE: potrebujeme context na taxonomy → načítame content (tvoje „druhé volanie“)
      dataService.axiosFetch("content", nid)
        .then(res => fillFromResults(res, overrideForNid))
        .then(() => { this.productLoaded = true; })
        .catch(err => { console.error(err); this.productLoaded = true; });
    } else {
      // bez override: načítaj content a pokračuj rovnako
      dataService.axiosFetch("content", nid)
        .then(res => fillFromResults(res, null))
        .then(() => { this.productLoaded = true; })
        .catch(err => { console.error(err); this.productLoaded = true; });
    }
  } else {
    // fallback vetva bez override nastavení
    dataService.axiosFetch("content", nid)
      .then(res => fillFromResults(res, null))
      .then(() => { this.productLoaded = true; })
      .catch(err => { console.error(err); this.productLoaded = true; });
  }
},
manageOptions(forceReload = false) {
  // zozbieraj polia
  const getFields = [];
  this.elements.forEach(obj => {
    if (this.data[obj]) getFields.push(this.data[obj]);
  });

  // mapa slug -> fieldId pre typ 12
  const chooseFrom = {};
  (this.context?.contenttypes?.fields || []).forEach(f => {
    if (+f.type === 12) chooseFrom[f.slug] = f.id;
  });

  const promises = [];

  getFields.forEach(slug => {
    if (+this.fieldTypes[slug] !== 12) return;

    const alreadyLoaded =
      Array.isArray(this.fieldOptions?.[slug]) && this.fieldOptions[slug].length > 0;

    // Ak už máme možnosti a nechceme vynútiť reload, nič nerobíme
    if (alreadyLoaded && !forceReload) {
      return; // nepíšeme do fieldOptions a nerefreshujeme
    }

    const taxonomyId = this.context?.context?.[chooseFrom[slug]];
    if (taxonomyId == null) return;

    // (Pozn: už nevymazávame existujúce options pred fetchom!)
    const p = dataService
      .axiosFetch('taxonomyitems', taxonomyId)
      .then(items => {
        const opts = (items || []).map(res => ({ value: res.id, label: res.title }));
        if (this.$set) this.$set(this.fieldOptions, slug, opts);
        else this.fieldOptions[slug] = opts;
      })
      .catch(err => {
        console.error('taxonomyitems failed for', slug, taxonomyId, err);
      });

    promises.push(p);
  });

  return Promise.all(promises);
},
            openProductSearch(slug)
            {
              this.productSearch = true;
              this.productSlug = slug;


            },
            copypaste(el,v)
            {

                const self = this;
                let tArea = this.$refs.yourTextarea;

                let startPos = tArea.selectionStart,
                    endPos = tArea.selectionEnd,
                    cursorPos = startPos,
                    tmpStr = tArea.value;

                self.data.settings.templates[el] = tmpStr.substring(0, startPos) + '*' + v + '*' + tmpStr.substring(endPos, tmpStr.length);
                // move cursor:
                setTimeout(() => {
                    cursorPos += v.length;
                    tArea.selectionStart = tArea.selectionEnd = cursorPos;
                }, 10);
            }
        },
        mounted() {



            dataService.axiosFetch('contenttypes').then(results => {
                this.contenttypes = results;
            });
            dataService.axiosFetch('taxonomies').then(results => {
                this.taxonomies = results;
            });
            dataService.axiosFetch('languages').then(results => {
                this.dataLang.push({"id":'und',"title":"Nezávislé od jazyka"});
                results.forEach(obj => { this.dataLang.push({"id" : obj.short , "title" : obj.title}); });
            });
            if(this.data.settings.contentType)
            {
                dataService.axiosFetch('contenttype',this.data.settings.contentType).then(results => {
                    this.contenttypeFields = results;

    results.fields.forEach(obj => {

this.selectedFields[obj.id] = obj;

                     });

                     results.fields.forEach(obj => {

this.fieldTypes[obj.slug] = obj.type;

                     });
                });


                dataService.axiosFetch('contenttype',this.selectedCT).then(results => {
                     results.fields.forEach(obj => { this.mainFields.push(obj.slug); });

                     results.fields.forEach(obj => {

this.selectedFields[obj.id] = obj;

                     });
                });

                if(Array.isArray(this.data.settings.templates))
               { this.data.settings.templates = {};}
            }
            else {
                this.data.settings.contentType = "";
               this.data.settings.templates = {};
            }
            if(this.vocabulary)
            {
                dataService.axiosFetch('taxonomy',this.vocabulary).then(results => {
                    this.contenttypeFields = results;
                });
            }



        }
    }
</script>

<style scoped>
    .elements >>> .ant-select
    {width:95%}
    .elements >>> .ant-row
    {margin-bottom:0px}

    .elements
    {width:60%;display:inline-block;padding-left:5%;}
    .element >>> .ant-form-item-label
    {width:100%; text-align:left;line-height:20px;}
    .element >>> .ant-form-item-label label
    {margin:0;padding:0;margin-top:5px;margin-bottom:5px;}

    .field-setup
    {display:inline;float:right;width:5%}
    .field-setup i{
        font-size:14px; padding:14px;
        color: #33325e;
        float:left;margin:0;
    }
    .additional-setup >>> .ant-select
    {
        width:100%;
    }
    .override-text
    {    line-height: 17px;
    }
    .override-text li{
        margin:0;
    }
    .override-node
    {
      border:1px solid #efefef;
      padding:15px;
      margin-top:10px;
      border-radius:7px;
    }
    .field-setup i:hover
    {background-color:rgba(255,255,255,.7);cursor:pointer;}

    .setup-item >>> .ant-select
    {width:100%;}

</style>
